.cardBackground {
  background-color: white;
  border-radius: 10px;
  width: 400px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

[data-mantine-color-scheme='dark'] .cardBackground {
  background-color: var(--mantine-color-dark-7);
  color: var(--mantine-color-dark-0);
}

/* Make selects transparent */
select {
  background-color: transparent;
}

.outerContentWrapper {
  margin: 32px;
  position: relative;
}

.outerContentWrapper h2 {
  margin: 0;
  padding: 0;
}

.fieldsWrapper {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  margin: 32px 0;
}

.footer {
  display: flex;
  width: 100%;
  column-gap: 8px;
}

.cancelButton:focus {
  color: #ff00bf;
  outline-color: #ff00bf;
}

.statusAlert {
  display: flex;
  align-items: center;
}

[data-mantine-color-scheme='dark'] select option {
  background-color: var(--mantine-color-dark-7);
  color: var(--mantine-color-dark-0);
}

[data-mantine-color-scheme='dark'] .react-select__menu {
  background-color: var(--mantine-color-dark-7) !important;
}

[data-mantine-color-scheme='dark'] .react-select__option {
  color: var(--mantine-color-dark-0) !important;
}
